// extracted by mini-css-extract-plugin
module.exports = {"blockerContainer":"BlockerForm_blockerContainer__3F7my","form":"BlockerForm_form__2vsTu"};